module.exports = __webpack_public_path__ + "static/media/filter.8daf7988.svg";